module.exports = __webpack_public_path__ + "img/success-icon.c18cd8b0.svg";